import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CartService {

  private cart = [];
  private cartItemCount = new BehaviorSubject(0);

  constructor() { }

  getCart() {
    return this.cart;
  }

  setCart(cart) {
    this.cart = cart;
  }

  getCartItemCount() {
    return this.cartItemCount;
  }

  clearCart() {
    this.cart = [];
  }

  addProduct(product) {
    this.cart.push(product);
  }

  addDirectDonation(product, count) {
    console.log(this.cart.length);
    if (this.cart.length > 0){
      this.cart = [];
    }
    for (let i = 0; i < count; i++) {
      this.cart.push(product);
    }
  }


}
